import { useLocation, useHistory } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
import { getSearchParamsObject } from '@utils/commonUtils';

export function useSearchParams() {
  const { search } = useLocation();

  const searchParams = useMemo(() => getSearchParamsObject(search), [search]);

  return searchParams;
}

export function useUpdateQueryParams() {
  const history = useHistory();
  const { search } = useLocation();

  return useCallback(
    (updates) => {
      const currentParams = getSearchParamsObject(search);

      // Merge and stringify
      const newParams = new URLSearchParams({
        ...currentParams,
        ...updates,
      });

      // Remove empty/null values
      Object.keys(updates).forEach((key) => {
        if (updates[key] === null || updates[key] === undefined || updates[key] === '') {
          newParams.delete(key);
        }
      });

      history.push({ search: newParams.toString() });
    },
    [history, search],
  );
}
